import SamplesTable from '@/components/Samples/SamplesTable';
import { type FC } from 'react';
import Header from '@/components/UI/Header';

export const TeamSamplesTable: FC = () => {
  return (
    <>
      <div className="ph4 pb3">
        <Header mainHeaderText="Samples" className="mb3" />
        <SamplesTable />
      </div>
    </>
  );
};
